// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1C0w3","fileBtn":"File_fileBtn__3fMP7","closeBtn":"File_closeBtn__lixqP","fileSelected":"File_fileSelected__2bdcs","disabled":"File_disabled__Wn7IK"};